<template>
  <x-input v-model="input" @change="emitValue" :name="name" :custom-validity="validity" :title="validity || undefined" type="domain" :required="required" :placeholder="$t('Ad esempio dominio.ch')" />
  <p v-if="showPrezzo && wizard.codiceProdottoDominio && !wizard.sottodominio">
    <wizard-price-tag :product="wizard.getProdotto(wizard.codiceProdottoDominio)" />
  </p>
</template>

<script setup lang="ts">
import { useWizardQuestion, type WizardInjection } from '@/wizard';
import WizardPriceTag from '../wizard-price-tag.vue';
import { computed, shallowRef, watch } from 'vue';
import { $t as _t } from '@/i18n';
import { watchDebounced } from '@vueuse/core';

type ValueType = NonNullable<WizardInjection['nomeDominio']>;

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  modelValue: ValueType;
  name: string;
  required?: boolean;
  showPrezzo?: boolean;
}>();

const $emit = defineEmits<{
  (name: 'update:modelValue', v: ValueType): void;
}>();

const { wizard } = useWizardQuestion();

const input = shallowRef<ValueType>('');

watch(
  () => props.modelValue,
  v => (input.value = v || ''),
  { immediate: true },
);

function emitValue() {
  if (input.value !== props.modelValue) {
    $emit('update:modelValue', input.value);
  }
}

// Il debounce evita di ricalcolare prodotti e validità a ogni tasto; al change (blur o invio) il valore
// viene propagato subito, così lo step successivo non parte con il dominio precedente.
watchDebounced(input, emitValue, {
  debounce: 500,
  maxWait: 2000,
});

const validity = computed(() => {
  if (wizard.path === 'dominio' && wizard.sottodominio) {
    return _t('Non è possibile registrare un sottodominio: indica il dominio principale.');
  }
  if ((wizard.path === 'dominio' || ((wizard.askDomainFirst || wizard.askDomainAddon) && wizard.attivaDominio)) && !wizard.dominioRegistrabile && !wizard.sottodominio) {
    return _t("L'estensione del dominio non è fra quelle disponibili per la registrazione.");
  }
  return '';
});
</script>
